import React, { useEffect, useState } from 'react';
import APIService from '../../shared/services/api';

interface PrivacyData {
    id: number;
    title: string;
    type: number;
    content: string;
    createdAt: string;
    updatedAt: string;
}

const PrivacyPolicy: React.FC = () => {
    const [data, setData] = useState<PrivacyData | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        fetchPrivacy();
    }, []);

    const fetchPrivacy = async () => {
        try {
            const res = await APIService.getAll(`terms-condition`, false);

            const PRIVACY_POLICY = "Privacy policy";
            const responseData = res?.data?.data;

            if (responseData) {
                const findPrivacy = responseData.find(
                    (item: PrivacyData) => item.title === PRIVACY_POLICY
                );

                if (findPrivacy) {
                    setData(findPrivacy);
                }
            }
        } catch (error) {
            console.error('Error fetching privacy policy:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div>Loading...</div>;
    if (!data) return <div>No data found</div>;

    return (
        <>
            <style>
                {`
                .terms-wrapper {
                    background: #f5f7fb;
                    height: 100vh;
                    padding: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .terms-card {
                    background: #fff;
                    max-width: 900px;
                    width: 100%;
                    height: 90vh;
                    border-radius: 12px;
                    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                }

                .terms-header {
                    padding: 20px;
                    border-bottom: 1px solid #eee;
                    font-size: 24px;
                    font-weight: 600;
                    text-align: center;
                    background: #fff;
                    position: sticky;
                    top: 0;
                    z-index: 10;
                }

                .terms-content {
                    padding: 20px 30px;
                    overflow-y: auto;
                    flex: 1;
                    font-size: 15px;
                    line-height: 1.7;
                    color: #333;
                    scroll-behavior: smooth;
                }

                .terms-content::-webkit-scrollbar {
                    width: 8px;
                }

                .terms-content::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 10px;
                }

                .terms-content::-webkit-scrollbar-thumb:hover {
                    background: #999;
                }
                `}
            </style>

            <div className="terms-wrapper">
                <div className="terms-card">
                    <div className="terms-header">
                        {data.title}
                    </div>

                    <div
                        className="terms-content"
                        dangerouslySetInnerHTML={{ __html: data.content }}
                    />
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;